<script>
  import Block from '@components/general/block'
  import Button from '@components/buttons/button.svelte'
  import { CONSENT_KEY } from '@lib/utils/cookie-consent'
  import { appState } from '@state/app-state.svelte.js'
  import { toast } from 'svelte-sonner'
  import posthog from 'posthog-js'

  let toggling = $state(false)

  function toggleCookies() {
    toggling = true
    setTimeout(() => {
      appState.cookieConsent = !appState.cookieConsent
      if (appState.cookieConsent) {
        posthog.opt_in_capturing()
        localStorage.setItem(CONSENT_KEY, 'accepted')
        window.altruistCaptureCurrentPageview?.({ force: true })
      } else {
        posthog.opt_out_capturing()
        localStorage.setItem(CONSENT_KEY, 'declined')
      }
      toggling = false
      toast.success(appState.cookieConsent ? 'Cookies enabled' : 'Cookies disabled')
    }, 300)
  }

</script>

<Block.Element label="Privacy" title="Cookie preferences">
  <div class="flex flex-col gap-3">
    
    <p class="text-smaller text-gray-500">We use cookies to help us understand how you use the site and improve your experience.</p>
    
    <p class="text-smaller text-gray-500">
      Analytics cookies are currently 
      <strong>{appState.cookieConsent ? 'enabled' : 'disabled'}.</strong>
    </p>
    
    <Button
      variant={appState.cookieConsent ? 'warning' : 'primary'}
      text={appState.cookieConsent ? 'Disable cookies' : 'Enable cookies'}
      onclick={toggleCookies}
      loading={toggling}
    />

  </div>
</Block.Element>
